/**
 * NarcisMark — the daffodil glyph, lifted verbatim out of `components/Header/header.tsx`'s inline
 * SVG (six petals + the yolk center, the same tokens `styles/partials/colors.scss` names `--yolk`/
 * `--text`) so the wall's own header and sign-in card (`products/narcis/wall/{header,signInCard}
 * .tsx`) share one mark rather than each inlining the same eight shapes.
 */
export function NarcisMark({size = 28}: {size?: number}) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" />
            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(60 32 32)" />
            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(120 32 32)" />
            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(180 32 32)" />
            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(240 32 32)" />
            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(300 32 32)" />
            <circle cx="32" cy="32" r="9" fill="#E8C24A" />
            <circle cx="32" cy="32" r="9" fill="none" stroke="#FAFAF9" strokeWidth="0.8" />
        </svg>
    )
}
